"use strict";

define('controller/study/detail',['require','exports','module','underscore','../base','templates','config','datakit/collection','appkit/changes.helper','model/study','model/document','model/flag','model/template','model/study.proposal','model/sp.proposal','model/product','model/docstore','collection/assignments','libs/route.helper','libs/browser.helper','libs/format/link','libs/format/string','libs/format/date','libs/format/status','view/study.detail','view/study/submission.tab','view/empty.table','view/decision.header','uikit/uikit','langs','model/sort'],function (require, exports, module) {
  var _ = require('underscore'),
    RegionController = require('../base'),
    Templates = require('templates'),
    config = require('config'),
    BaseCollection = require('datakit/collection'),
    ChangesHelper = require('appkit/changes.helper'),
    Study = require('model/study'),
    Document = require('model/document'),
    Flag = require('model/flag'),
    Template = require('model/template'),
    StudyProposal = require('model/study.proposal'),
    SPProposal = require('model/sp.proposal'),
    Product = require('model/product'),
    DocStoreModel = require('model/docstore'),
    Assignments = require('collection/assignments'),
    RouteHelper = require('libs/route.helper'),
    BrowserHelper = require('libs/browser.helper'),
    linkFormatter = require('libs/format/link'),
    stringFormatter = require('libs/format/string'),
    dateFormatter = require('libs/format/date'),
    statusFormatter = require('libs/format/status'),
    StudyDetailView = require('view/study.detail'),
    SubmissionTabContent = require('view/study/submission.tab'),
    EmptyTableView = require('view/empty.table'),
    DecisionHeaderView = require('view/decision.header'),
    UIKit = require('uikit/uikit'),
    langs = require('langs'),
    Sort = require('model/sort');
  var documentLinkFormatter = linkFormatter('submission:detail', {
    studyId: 'studyId',
    documentId: 'id'
  });
  var decisionHeaderOptions = {
    bindings: {
      status: 'decisionStatus',
      date: 'decisionResultDate'
    }
  };
  var SUBMISSIONS_COLUMNS = [{
    text: 'Submission Type',
    data: 'templateType',
    formatter: documentLinkFormatter
  }, {
    text: 'Review Type',
    data: 'reviewType',
    formatter: stringFormatter('Capitalize')
  }, {
    text: 'Status',
    data: 'status',
    formatter: statusFormatter()
  }, {
    text: 'Decision',
    childView: DecisionHeaderView,
    childViewOptions: decisionHeaderOptions
  }];
  var PROPOSAL_COLUMNS = [{
    text: 'Proposal #',
    data: 'PROPOSALNUMBER'
  }, {
    text: 'Lead PI',
    data: 'LEADFULLNAME'
  }, {
    text: 'Status',
    data: 'PROPOSALSTATUS'
  }, {
    text: 'Begin Date',
    data: 'PROJECTBEGINDATE',
    formatter: dateFormatter(config.dateFormat)
  }, {
    text: 'End Date',
    data: 'PROJECTENDDATE',
    formatter: dateFormatter(config.dateFormat)
  }];
  var RootView = Mn.ItemView.extend(UIKit.ComponentMixin).extend({
    useInjector: true,
    template: Templates.IRB['page.tabs'],
    options: {
      hideSectionTitleFromScreens: true,
      sectionTitle: langs.phrase('StudiesPage.Details.Title')
    }
  });
  var PlaceholderView = Mn.ItemView.extend(UIKit.ComponentMixin).extend({
    template: false
  });
  var StudyDetailController = RegionController.extend({
    header: langs.phrase('App.Title'),
    onStart: function onStart() {
      var app = this.app,
        region = this.region,
        state = this.state;
      var studyModel = new Study({
          id: state.get('studyId'),
          title: ''
        }),
        permissions = studyModel.permissions(),
        studyService = app.service('study'),
        changesHelper = new ChangesHelper().add(studyModel),
        documents = Document.all(state.get('studyId')),
        activeDocs = Document.all(state.get('studyId')),
        assignments = new Assignments(),
        fTemplates = Template.allPublishedByStudyId(),
        studyProposals = StudyProposal.allByStudyId(),
        studyAttachments = DocStoreModel.createCollection(DocStoreModel.STUDY_ATTACHMENT_URL),
        linkedProposals = new BaseCollection(),
        studyContacts = new BaseCollection(),
        studyContactAssignments = new BaseCollection(),
        availableFlags = Flag.all(),
        proposals = SPProposal.all(studyContacts),
        PROPOSAL_LINK_COLUMNS = PROPOSAL_COLUMNS.slice();
      var uploadHandler = DocStoreModel.buildUploadHandler(app, DocStoreModel.STUDY_ATTACHMENT_URL, {
        studyId: studyModel.id
      }, studyAttachments.fetch.bind(studyAttachments));
      var page = new RootView(),
        bottomSegmentView = new PlaceholderView({
          visible: false
        }).render(),
        submissionsTabContent = new SubmissionTabContent(),
        studyDetailView = new StudyDetailView({
          app: app,
          assignments: assignments,
          activeDocuments: activeDocs,
          attachments: studyAttachments,
          documents: documents,
          availableFlags: availableFlags,
          canModifyFlags: this.userHasPermission('IRB_MODIFY_STUDY_FLAGS'),
          canModifyStudy: this.userHasPermission('MODIFY_STUDY'),
          model: studyModel,
          state: state,
          formTemplates: fTemplates,
          uploadHandler: uploadHandler
        }).on('render', function () {
          bottomSegmentView.setElement(this.ui.bottomTabs);
        }),
        overlay = app.overlay,
        proposalLinkView = null,
        documentId = Number(state.get('documentId'));
      changesHelper.listenTo(page, 'destroy', changesHelper.off);
      var unsavedModalEvents = app.request('modal', {
        type: 'UNSAVED_CHANGES',
        state: changesHelper
      }, {
        ariaControlsId: 'studyDetails'
      });
      activeDocs.addAdapter({
        preprocess: function preprocess(options) {
          options.data = _.extend({
            active: true
          }, options.data);
          return options;
        }
      });
      function newEmptyView() {
        return new EmptyTableView.Loading();
      }
      function canLinkProposal() {
        return !!((app.authorities.get('ROLE_IRB_ANALYST') || assignments.findWhere({
          personId: app.user.person.id
        })) && app.products.findWhere({
          name: Product.SP_PRODUCT
        }));
      }
      function updateProposalLinkBtnVisibility() {
        studyDetailView.linkProposalBtn.visible = canLinkProposal();
      }
      function updateLinkedProposalVisibility() {
        if (linkedProposals.isEmpty() && false) {
          studyDetailView.linkedProposalsTab.menuItem.visible = false;
        } else {
          studyDetailView.linkedProposalsTab.menuItem.visible = true;
        }
      }
      function onProposalAdd(proposal) {
        var studyProposal = StudyProposal.create(studyModel, proposal);
        studyProposals.add(studyProposal);
        studyProposal.createLink();
      }
      function onProposalRemove(proposal) {
        var studyProposal = studyProposals.findWhere({
          proposalId: proposal.id
        });
        if (studyProposal) {
          studyProposal.destroyLink();
        }
      }
      function setupLinkedCheckbox(view, model) {
        view.value = !!studyProposals.findWhere({
          proposalId: model.id
        });
        view.listenTo(studyProposals, 'add remove', _.debounce(function () {
          view.value = !!studyProposals.findWhere({
            proposalId: model.id
          });
        }, 1)).on('change:value', _.debounce(function () {
          if (view.value) {
            onProposalAdd(model);
          } else {
            onProposalRemove(model);
          }
        }, 10));
      }
      function tryProposalFetch() {
        if (app.products.findWhere({
          name: Product.SP_PRODUCT
        })) {
          proposals.fetch().promise()["catch"](function () {
            throw new Error('Cayuse SP currently unavailable.');
          });
        } else {
          state.removePageResources(proposals);
        }
      }
      function setupRemoveButton(view, model) {
        view.on('press', function () {
          onProposalRemove(model.get('proposal'));
        });
      }
      function syncProposalsToStudyProposals() {
        var filteredStudyProposals = studyProposals.filter(function (studyProposal) {
          var proposal = proposals.get(studyProposal.get('proposalId'));
          studyProposal.set('proposal', proposal);
          return !!proposal;
        });
        if (proposals.fetched) {
          studyProposals.set(filteredStudyProposals);
        }
        linkedProposals.set(_.compact(studyProposals.pluck('proposal')));
      }
      PROPOSAL_LINK_COLUMNS.push({
        text: 'Linked',
        childView: UIKit.Checkbox,
        childViewOptions: {
          toggle: true
        },
        onBeforeAdd: setupLinkedCheckbox
      });
      proposalLinkView = new UIKit.Container().add(new UIKit.Text({
        text: 'Link Proposals',
        className: 'ui header',
        tagName: 'h3'
      })).add(new UIKit.Grid({
        evenSizes: false
      }).add(new UIKit.Container({
        className: 'ui segment fitted'
      }).add(new UIKit.Table({
        columns: PROPOSAL_LINK_COLUMNS,
        basic: true,
        borderless: true,
        sortable: false,
        padded: true,
        selectable: true,
        emptyText: 'No Proposals.',
        collection: proposals
      })), {
        wide: 'ten'
      }).add(new UIKit.Container({
        className: 'ui segment fitted'
      }).add(new UIKit.Table({
        columns: [{
          text: 'Linked Proposals',
          data: 'proposalNumber'
        }, {
          collapsing: true,
          childView: UIKit.Button,
          childViewOptions: {
            icon: 'remove',
            inline: true
          },
          onBeforeAdd: setupRemoveButton
        }],
        basic: true,
        borderless: true,
        sortable: false,
        padded: true,
        emptyText: 'No Linked Proposals.',
        collection: studyProposals
      })), {
        wide: 'six'
      }));
      submissionsTabContent.setupCollection(documents, {
        autoFetch: true
      }).setupSortDefaults({
        sort: 'createDate',
        sortDirection: Sort.ASCENDING
      }).setupLoading().setupRowLink('submission:detail', {
        studyId: 'studyId',
        documentId: 'id'
      }).setupPaginate().setupPageSizes().setupColumns(SUBMISSIONS_COLUMNS);
      page.createDropdown.color = 'primary';
      page.createDropdown.disabled = true;
      page.createDropdown.floated = 'right';
      page.createDropdown.floating = true;
      page.createDropdown.icon = 'plus';
      page.createDropdown.iconRight = false;
      page.createDropdown.mode = 'button';
      page.createDropdown.pointing = 'top right';
      page.createDropdown.text = 'New Submission';
      page.createDropdown.collection = fTemplates;
      page.createDropdown.childBindings = {
        text: 'type'
      };
      page.createDropdown.on('press', function (fTemplate) {
        if (fTemplate.get('type') == 'Withdrawal') {
          app.request('modal', {
            icon: 'warning circle icon',
            approveBtn: {
              text: 'Withdraw',
              color: 'red'
            },
            content: 'By creating this withdrawal submission, you will be withdrawing the entire study from review. If you still wish to submit this submission, you will have to restart your application from the beginning. Are you sure you would like to proceed?',
            header: fTemplate.get('type'),
            type: 'CONFIRM'
          }).on('confirm', function () {
            studyService.createSubmission(studyModel, fTemplate, app.user, documents);
          });
        } else {
          studyService.createSubmission(studyModel, fTemplate, app.user, documents);
        }
      });
      studyDetailView.linkedProposalsTable.collection = linkedProposals;
      studyDetailView.linkedProposalsTable.selectable = true;
      studyDetailView.linkedProposalsTable.rowLinkTarget = '_blank';
      studyDetailView.linkedProposalsTable.rowLinkFormatter = function (model) {
        return model.get('link');
      };
      studyDetailView.studyContactsTable.collection = studyContactAssignments;
      studyDetailView.linkProposalBtn.on('press', function () {
        overlay.content.show(proposalLinkView, {
          buttonType: 'done'
        });
        overlay.active = true;
      });
      studyDetailView.attachmentsTabView.setupPaginate().setupPageSizes().setupTableSort().setupLoading().setupSearch('').spfHelper.setupAutoFetch().setSortField('createDate').setSortDirection('ascending').setPaginateSize(10);
      page.$el.css(config.contentCss);
      page.breadcrumb.collection = new BaseCollection([{
        text: 'Studies',
        link: RouteHelper.resolve('study:list')
      }, {
        text: langs.phrase('StudiesPage.Details.Title')
      }]);
      page.tabs.tabListAriaLabel = langs.phrase('StudiesPage.Details.TopTabs.ARIALabel');
      page.tabs.menu.dark = true;
      page.tabs.menu.tabular = false;
      page.tabs.menu.attached = '';
      page.tabs.menu.fluid = true;
      page.tabs.menu.dark = true;
      page.tabs.add('Study Details', studyDetailView);
      page.tabs.add('Submissions', submissionsTabContent);
      page.tabs.each(function (view) {
        view.$el.addClass('basic fitted');
        view.attached = '';
      });
      var pageModels = [studyModel, documents, activeDocs, assignments, fTemplates];
      function pageLoad(preventDestroy) {
        var options = {
          preventDestroy: preventDestroy
        };
        bottomSegmentView.visible = true;
        state.once('page:loaded', function () {
          region.show(page, options);
        }).once('page:error', function () {
          studyService.navigateToStudies();
        });
      }
      if (!studyModel.isNew()) {
        pageLoad();
        state.addPageDependencies(pageModels);
        studyModel.fetch().promise().tap(fetchAllStudyDetails);
      } else {
        region.show(page);
        state.trigger('page:loaded');
      }
      page.listenTo(studyDetailView, 'create:study', function () {
        var xhr = studyModel.save();
        if (xhr) {
          xhr.promise().tap(function () {
            pageLoad(true);
            state.addPageDependencies(pageModels);
            state.removePageResources(studyModel);
            fetchAllStudyDetails();
          });
        }
      }).listenTo(studyDetailView, 'edit:study', function () {
        studyModel.save();
      });
      function fetchAllStudyDetails() {
        state.changeRouteName('study:detail').set('studyId', studyModel.id);
        documents.params({
          studyId: studyModel.id
        });
        activeDocs.params({
          studyId: studyModel.id
        });
        assignments.params({
          entityType: 'study',
          entityId: studyModel.id
        });
        fTemplates.params({
          studyId: studyModel.id
        });
        studyProposals.params({
          studyId: studyModel.id
        });
        studyAttachments.params({
          studyId: studyModel.id
        });
        return Promise.join(documents.fetch(), activeDocs.fetch(), assignments.fetch(), availableFlags.fetch(), fTemplates.fetch(), studyProposals.fetch(), studyAttachments.fetch(), permissions.fetch());
      }
      page.listenTo(unsavedModalEvents, 'save:model', function () {
        studyModel.save();
      }).listenTo(fTemplates, 'sync', function () {
        page.createBtn.visible = false;
        page.createDropdown.visible = true;
        page.createDropdown.disabled = !fTemplates.length;
      }).listenTo(studyModel, 'sync', function () {
        var studiesLinkModel = page.breadcrumb.collection.at(0),
          isArchived = !!studyModel.get('finalizedDate');
        studiesLinkModel.set({
          link: RouteHelper.resolve('study:list', {
            type: isArchived ? 'archive' : 'active'
          })
        });
      }).listenTo(studyModel, 'destroy', function () {
        _.defer(function () {
          app.navigate(RouteHelper.resolve('study:list'), {
            trigger: true
          });
        });
      }).listenTo(assignments, 'sync', function () {
        updateProposalLinkBtnVisibility();
        studyContactAssignments.set(assignments.getByFinderType('person').models);
        studyContacts.set(studyContactAssignments.pluck('person'));
        if (app.products.fetched) {
          tryProposalFetch();
        } else {
          page.listenToOnce(app.products, 'sync', tryProposalFetch);
        }
      }).listenTo(studyProposals, 'add remove', _.debounce(function () {
        syncProposalsToStudyProposals();
      }, 1)).listenTo(proposals, 'sync', function () {
        syncProposalsToStudyProposals();
      }).listenTo(linkedProposals, 'add remove', _.debounce(function () {
        updateLinkedProposalVisibility();
      }, 1)).listenTo(app.products, 'sync', function () {
        updateProposalLinkBtnVisibility();
      }).listenTo(permissions, 'sync', function () {
        studyDetailView.titleField.editable = permissions.get('canEdit');
        studyDetailView.changeOrgView.editable = permissions.get('canEditOrgAssignment');
      });
      if (!BrowserHelper.isIE()) {
        _.defer(function () {
          if (studyDetailView.titleField.editing) {
            studyDetailView.titleField.input.focus();
          }
        });
      }
    }
  });
  module.exports = StudyDetailController;
});

